import { render, staticRenderFns } from "./StugermanTable.vue?vue&type=template&id=45495837&scoped=true&"
import script from "./StugermanTable.vue?vue&type=script&lang=js&"
export * from "./StugermanTable.vue?vue&type=script&lang=js&"
import style0 from "./StugermanTable.vue?vue&type=style&index=0&id=45495837&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45495837",
  null
  
)

export default component.exports